import { Input } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldPassword = ({ value, onChange, ...props }) => {
  return (<Input.Password rows={4} value={value} onChange={onChange} {...props} />);
};

DynamicFieldPassword.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldPassword);
